import './card.scss'
import React from 'react';
import type {CardProps} from '../../types';

export default function Card(props: React.PropsWithChildren<CardProps>) {
	return (
		<div className={'dx-card card' + (!!props.className ? ' ' + props.className : '')}>
			<div className='card-header'>
				{props.header}
			</div>
			<div className='card-content'>
				{props.children}
			</div>
		</div>
	)
}
